// Espelho de cabine-foto-gestao/src/constants/types/molduraEvento.js
// Molduras fixas de um totem do tipo EVENTO. Ficam no doc
// personalizaTotem/{totemUID}, campo `molduras`:
//   { id, nome, tipo: "normal" | "polaroid",
//     orientacao: "RETRATO" | "PAISAGEM", url, storagePath }
//
// A regra vale por tipo de foto: se o tipo tem uma ou mais molduras fixas, TODA
// foto daquele tipo é impressa com uma delas — não existe imprimir sem moldura.
// Tipo sem moldura fixa (ex.: só a polaroid foi configurada) segue o
// comportamento normal: molduras globais e moldura opcional.
export const tipoMolduraEvento = {
  NORMAL: "normal",
  POLAROID: "polaroid",
};

export const orientacaoMolduraEvento = {
  RETRATO: "RETRATO",
  PAISAGEM: "PAISAGEM",
};

const TIPOS_VALIDOS = Object.values(tipoMolduraEvento);

// Moldura cadastrada antes de o gestão gravar `orientacao` não tem o campo:
// naquela época toda moldura de evento era retrato. Polaroid não gira no
// totem, então é sempre retrato — a mesma regra do cadastro no gestão.
export const orientacaoDaMolduraEvento = (moldura) =>
  moldura.tipo === tipoMolduraEvento.NORMAL &&
  moldura.orientacao === orientacaoMolduraEvento.PAISAGEM
    ? orientacaoMolduraEvento.PAISAGEM
    : orientacaoMolduraEvento.RETRATO;

// O doc é escrito pelo gestão; aqui só entra o que o editor sabe renderizar, e
// toda moldura sai com a orientação preenchida.
export const normalizaMoldurasEvento = (molduras) => {
  if (!Array.isArray(molduras)) return [];
  return molduras
    .filter((item) => item && item.url && TIPOS_VALIDOS.includes(item.tipo))
    .map((item) => ({ ...item, orientacao: orientacaoDaMolduraEvento(item) }));
};

export const filtrarMoldurasEventoPorTipo = (molduras, tipo) =>
  normalizaMoldurasEvento(molduras).filter((item) => item.tipo === tipo);
